import React from "react";
import { changeTypeToName } from "../../helper/changeBankIdtoName";
const ResultBar = (props) => {
  const huayType = [
    "bon_6",
    "bon_5",
    "bon_4",
    "bon_3",
    "tode_3",
    "na_3",
    "lang_3",
    "bon_2",
    "lang_2",
    "bon_1",
    "lang_1",
  ];

  return (
    <div className="w-auto h-auto mt-1 overflow-auto text-[#f8eede] bg-white pb-40">
      <div className="flex justify-between bg-[#b3853e] px-1 py-1 text-normal">
        <p className="mt-1">
          {/* <span className="mx-1">{JSON.parse(localStorage.getItem(localStorage.getItem("lotteryId")))?.length}</span> */}
          รายการเลขที่แทงทั้งหมด
        </p>

        <button
          id="deleteAllTickets"
          onClick={props.deleteListTickets}
          className="border border-[#f8eede] rounded px-1 py-1"
        >
          ยกเลิกทั้งหมด
        </button>
      </div>
      <div className="grid grid-cols-6 gap-1 px-1 md:grid-cols-12">
        {JSON.parse(localStorage.getItem(localStorage.getItem("lotteryId")))
          .length != 0 ? (
          huayType.map((type) =>
            JSON.parse(localStorage.getItem(localStorage.getItem("lotteryId")))
              ?.filter((data) => data.lotteryType == type)
              .map((number, i) => (
                <>
                  {i == 0 ? (
                    <>
                      <div className="col-span-6 md:col-span-12">
                        <p
                          className={`text-sm text-left text-gray-500 font-bold border-b mt-1`}
                        >
                          {changeTypeToName(type)}
                        </p>
                      </div>

                      <div className="col-span-1 text-center mt-0.5">
                        <p
                          className={`${
                            type == "bon_6"
                            ? `bg-purple-500`
                            : type == "bon_5" 
                              ? `bg-cyan-500`
                              : type == "bon_4" 
                              ? `bg-green-500`
                              : type == "bon_3" ||
                                type == "tode_3" ||
                                type == "na_3" ||
                                type == "lang_3"
                              ? `bg-yellow-500`
                              : type == "bon_2" || type == "lang_2"
                              ? `bg-orange-500`
                              : `bg-red-500`
                          } text-normal text-white rounded-full font-bold shadow-md `}
                        >
                          {number.lotteryNumber}
                        </p>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="col-span-1 text-center mt-0.5">
                        <p
                           className={`${
                            type == "bon_6"
                            ? `bg-purple-500`
                            : type == "bon_5" 
                              ? `bg-cyan-500`
                              : type == "bon_4" 
                              ? `bg-green-500`
                              : type == "bon_3" ||
                                type == "tode_3" ||
                                type == "na_3" ||
                                type == "lang_3"
                              ? `bg-yellow-500`
                              : type == "bon_2" || type == "lang_2"
                              ? `bg-orange-500`
                              : `bg-red-500`
                          } text-normal text-white rounded-full font-bold shadow-md `}
                        >
                          {number.lotteryNumber}
                        </p>{" "}
                      </div>
                    </>
                  )}
                </>
              ))
          )
        ) : (
          <p className="text-defaultPlayHuayDeactive mt-5 text-center text-normal col-span-6 md:col-span-12">
            ยังไม่มีรายการแทง
          </p>
        )}
      </div>
    </div>
  );
};

export default ResultBar;
